import {
	pgTable,
	text,
	doublePrecision,
	boolean,
	index,
	uuid,
	primaryKey
} from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";
import { baseTableProps } from "../../baseTableProps";
import { displayNameProps } from "../_shared/display-name";

export const addresses = pgTable(
	"addresses",
	{
		...baseTableProps,
		id: uuid("id").notNull().defaultRandom(),
		streetNumber: text("street_number").notNull().default("000"),
		streetName: text("street_name").notNull(),
		streetUnit: text("street_unit"),
		street1: text("street_1")
			.generatedAlwaysAs(sql`street_number || ' ' || street_name`)
			.notNull(),
		city: text("city").notNull(),
		state: text("state").notNull(),
		zip: text("zip").notNull(),
		county: text("county").notNull(),
		latitude: doublePrecision("latitude").notNull(),
		longitude: doublePrecision("longitude").notNull(),
		googlePlaceId: text("google_place_id").unique("addresses_google_place_id_unique"),
		validated: boolean("validated").notNull().default(false),
		...displayNameProps
	},
	(table) => [
		primaryKey({ name: "properties_pkey", columns: [table.id] }),
		index("addresses_street_name_idx").on(table.streetName),
		index("addresses_zip_idx").on(table.zip),
		index("addresses_state_city_idx").on(table.state, table.city),
		index("addresses_lat_lng_idx").on(table.latitude, table.longitude)
	]
);
